import { isOnStaging } from '../../../utils/env/isOnStaging/isOnStaging';

export const GlobalRoutes = {
	AboutHome: `/about`,
	AmlHome: `/aml`,
	ArtistsHome: `/artists`,
	ArtworksHome: '/artworks',
	DigitalHome: `/digital`,
	EditionsHome: `/editions`,
	ExhibitionsHome: `/exhibitions`,
	FabHome: `/fab`,
	FaqHome: `/faq`,
	FormsHome: `/forms`,
	GalleryHome: `/gallery`,
	HatHome: `/hat`,
	Home: '/',
	InvoiceHome: '/invoice',
	InvoiceCheckout: '/invoice/checkout',
	DropsHome: '/drops',
	LiveDrops: '/live-drops',
	JobsHome: `/jobs`,
	LeviathanHome: isOnStaging()
		? 'https://beta.leviathan.heni.com/'
		: 'https://leviathan.heni.com/',
	MerchHome: `/merch`,
	NewsHome: `/news`,
	NewsletterHome: '/newsletter',
	NftHome: `/nft`,
	PrimaryHome: `/primary`,
	PrivacyUk: `/privacy/uk`,
	PrivacyUs: `/privacy/us`,
	PrivacyUsMobile: '/privacy-mobile/us',
	PrivateSalesHome: `/private-sales`,
	PublishingHome: `/publishing`,
	RegisterInterest: '/register-interest',
	Search: '/search',
	SpinsHome: `/spins`,
	PodcastsHome: `/talks/podcasts`,
	TalksHome: `/talks`,
	TermsHome: `/terms`,
	VaultWidrawal: '/vault/withdraw',
	ShopHome: '/shop',
};
